import { useGetIdentity } from '@refinedev/core';
import { useMemo } from 'react';

import { CurrentUserDTO } from '../dto';
import { checkAuth } from '../helpers';
import { AuthParams } from '../types';

export const useCheckAuth = (authParams: AuthParams) => {
  const { data: user, isFetched: isFetchedIdentity } = useGetIdentity<CurrentUserDTO>();

  const isLoaded = isFetchedIdentity;

  const userHasRoles = user?.custom_roles && user.custom_roles.length > 0;
  const userEmailVerified = user?.email_verified;
  const userIsValid = userHasRoles && userEmailVerified;

  return useMemo(
    () => ({
      isPermitted: checkAuth(authParams, user),
      isLoaded,
      userIsValid,
    }),
    [authParams, user, isLoaded, userIsValid],
  );
};
